import { useEffect } from "react";

export default function Seo({ title, description, siteName = "Sobe Bevanda", image, jsonLd }) {
  useEffect(() => {
    const url = window.location.origin + window.location.pathname;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", siteName);

    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (image) {
      const abs = image.startsWith("http") ? image : window.location.origin + image;
      setMeta("property", "og:image", abs);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", abs);
    }

    let ld = document.head.querySelector("script[data-seo-jsonld]");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.setAttribute("type", "application/ld+json");
        ld.setAttribute("data-seo-jsonld", "true");
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, siteName, image, jsonLd]);

  return null;
}
